import { Components, Theme } from "@mui/material";

export const MODAL_THEME: Components<Theme>["MuiModal"] = {
  styleOverrides: {
    root: () => ({
      display: "flex",
    }),
  },
};
